module.exports = __webpack_public_path__ + "img/email2.f3107b64.svg";